import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        variant: "outlined",
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 8,
          backgroundColor: "#ffffff",
          ...(ownerState.multiline ? {} : { height: 44 }),
          "&.MuiAutocomplete-inputRoot": {
            height: "auto",
            minHeight: 44,
            alignItems: "center",
          },
        }),

        input: ({ ownerState }) => ({
          ...(ownerState.multiline
            ? {}
            : {
                padding: "0 14px",
                height: "100%",
                boxSizing: "border-box",
              }),
        }),

        inputMultiline: { padding: "12px 14px" },

        notchedOutline: { borderColor: "#000000" },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 13,
        },
      },
    },
  },
});
